import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ThankYou from "../pages/thank-you/page";
import LinkInBio from "../pages/link-in-bio/page";
import Calendar from "../pages/calendar/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import TermsAndConditions from "../pages/terms-and-conditions/page";
import CookiePolicy from "../pages/cookie-policy/page";
import Accessibility from "../pages/accessibility/page";
import DoNotSell from "../pages/do-not-sell/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/thank-you-6957",
    element: <ThankYou />,
  },
  {
    path: "/link-in-bio-2937",
    element: <LinkInBio />,
  },
  {
    path: "/calendar",
    element: <Calendar />,
  },
  {
    path: "/calendar-8097",
    element: <Calendar />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-and-conditions",
    element: <TermsAndConditions />,
  },
  {
    path: "/cookie-policy",
    element: <CookiePolicy />,
  },
  {
    path: "/accessibility",
    element: <Accessibility />,
  },
  {
    path: "/do-not-sell",
    element: <DoNotSell />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
